module.exports = __webpack_public_path__ + "static/media/subGoogle3.7cfafad5.png";